export type MapService = {
  id?: string;
  slug?: string;
  location?: string;
  manualUpdateTime?: string;
  automaticUpdateTime?: string;
  failUpdateTime?: string;
  mapServerId?: string;
  cordSysId?: string;
  isPollingDisabled?: boolean;
  countLayers?: number;
};

export enum MapServicePollTypes {
  MAP_SERVICE_LAYER_OVERWRITE = 'MAP_SERVICE_LAYER_OVERWRITE',
  MAP_SERVICE_NEW_LAYERS = 'MAP_SERVICE_NEW_LAYERS',
  MAP_SERVICE_KEEP_LAYER_CHANGES = 'MAP_SERVICE_KEEP_LAYER_CHANGES'
}
